let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j9v9C")).then(() => parcelRequire('9n6Sp'));